import { defineChain as viemDefineChain } from 'viem'

import type { AppChain } from './chain.types'

const viemTempo = viemDefineChain({
  id: 4217,
  name: 'Tempo',
  nativeCurrency: {
    name: 'USD',
    symbol: 'USD',
    decimals: 18
  },
  rpcUrls: {
    default: { http: ['https://rpc.tempo.xyz'] }
  },
  blockExplorers: {
    default: {
      name: 'Tempo Explorer',
      url: 'https://explore.tempo.xyz'
    }
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 0
    }
  }
})

export const tempo = {
  ...viemTempo,
  custom: {
    name: 'Tempo',
    shortName: 'Tempo',
    morphoChainSlug: 'tempo',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://explore.tempo.xyz', name: 'Tempo Explorer' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x112fd4042E442C3C12C67AD23587b0afe36eB74E',
          startBlock: 2145175n
        },
        MorphoBlue: { address: '0x10EE9AAC980A180dd4DcFc96C746d60B0EA88f97', startBlock: 2145175n }
      },
      v2: {
        VaultV20Factory: {
          address: '0x3DE400E3F79113194fa5AF6Ae5C474947E0C82Db',
          startBlock: 2145175n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xF85aD5f14cC903533FC409B8098B58b4C2f36697',
          startBlock: 2145175n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0x669771F03ab55CebF753E90C3c9D80ad9391cf25',
          startBlock: 16475630n
        },
        RegistryList: {
          address: '0xB118227C728b5ce52445a5aAee48C8a281C429E0',
          startBlock: 2145175n
        },
        BluePublicAllocator: {
          address: '0xDC9693CE6488640faEf173Ec2635ff99fdC25a07',
          startBlock: 35177253n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
